import React, { useState } from 'react';
import { EmailFormState } from '../../../types';
import { signupForUpdates } from '../../../api/signupApi';
import { ValidationError } from '../../../helpers/errors';
import EmailForm from './EmailForm';
import SuccessMessage from './SuccessMessage';

const EmailSignupForm: React.FC = () => {
  const [state, setState] = useState<EmailFormState>({
    email: '',
    isSubmitted: false,
    isLoading: false
  });
  const [error, setError] = useState<string | null>(null);
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleSubmit = async () => {
    if (!state.email || state.isLoading) 
      return;
    
    setState(prev => ({ ...prev, isLoading: true }));
    setError(null);
    setValidationError(null);
    
    try {
      console.log('Attempting to sign up with email:', state.email);
      const responseData = await signupForUpdates(state.email);
      console.log('Signup successful:', responseData);

      setState({
        email: '',
        isSubmitted: true,
        isLoading: false
      });
    } catch (error) {
      console.error('Signup error:', error);
      
      if (error instanceof ValidationError) {
        setValidationError(error.message);
      } else {
        // Handle other errors (network, server, etc.)
        let errorMessage = 'An unexpected error occurred';
        if (error instanceof TypeError && error.message === 'Failed to fetch') {
          errorMessage = 'Cannot connect to the server. Please check if the API is running on /api/signup';
        } else if (error instanceof Error) {
          errorMessage = error.message;
        }
        setError(errorMessage);
      }
      
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleEmailChange = (email: string) => {
    setState(prev => ({ ...prev, email }));
    if (error) setError(null);
    if (validationError) setValidationError(null);
  };

  if (state.isSubmitted) {
    return <SuccessMessage />;
  }

  return (
    <EmailForm
      email={state.email}
      isLoading={state.isLoading}
      error={error}
      validationError={validationError}
      onEmailChange={handleEmailChange}
      onSubmit={handleSubmit}
    />
  );
};

export default EmailSignupForm;